import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslationService } from '@sdbn/common';
import { TransportOptionParameterValue } from '../../../../client/model/transport-option';

export class ParameterSelectionDialogData {

  available: Array<TransportOptionParameterValue>;
  selected: Array<TransportOptionParameterValue>;

  constructor(data?: any) {
    if (data != null) {
      this.available = data.available;
      this.selected = data.selected;
    }
  }

}

export class TransportOptionParameterValueRef {

  id: number;
  label: string;
  assigned: boolean;

  constructor(value?: any) {
    if (value != null) {
      this.id = value.id;
      this.label = value.label;
    }
  }

}

@Component({
  selector: 'app-transport-option-parameter-selection',
  templateUrl: './transport-option-parameter-selection.component.html',
  styleUrls: ['./transport-option-parameter-selection.component.scss']
})
export class TransportOptionParameterSelectionComponent implements OnInit {

  selectedValues = new Array<TransportOptionParameterValueRef>();

  availableValues = new Array<TransportOptionParameterValueRef>();

  filteredValues = new Array<TransportOptionParameterValueRef>();

  formGroup = new FormGroup({
    query: new FormControl('', [])
  });

  constructor(
    public dialogRef: MatDialogRef<TransportOptionParameterSelectionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ParameterSelectionDialogData,
    public translationService: TranslationService
  ) {

    console.log('dialog data is', data);

    this.formGroup.valueChanges.subscribe(values => {
      this.doFilter(values.query);
    });

  }

  ngOnInit(): void {

    for (const item of this.data.available) {

      const value = new TransportOptionParameterValueRef({ id: item.id, label: this.translationService.translate(item.valueDictionaryKey) })
      this.availableValues.push(value);
      this.filteredValues.push(value);

    }

    for (const item of this.data.selected) {

      for (const value of this.availableValues) {
        if (value.id === item.id) {
          this.selectedValues.push(value);
          value.assigned = true;
        }
      }

    }

    this.sortValues();

  }

  doFilter(query: string) {

    const newValues = new Array<TransportOptionParameterValueRef>();

    for (const value of this.availableValues) {
      if (this.valueMatches(value, query)) {
        newValues.push(value);
      }
    }

    this.filteredValues = newValues;
  }

  valueMatches(value: TransportOptionParameterValueRef, query: string): boolean {
    var textA = value.label.toUpperCase();
    var textB = query.toUpperCase();
    return textA.includes(textB);
  }

  add(value: TransportOptionParameterValueRef) {
    this.selectedValues.push(value);
    value.assigned = true;
    this.sortValues();
  }

  remove(value: TransportOptionParameterValueRef) {
    this.selectedValues.forEach((element, index) => {
      if (element === value) this.selectedValues.splice(index, 1);
    });
    value.assigned = false;
    this.sortValues();
  }

  sortValues() {

    this.selectedValues.sort(function (a, b) {
      var textA = a.label.toUpperCase();
      var textB = b.label.toUpperCase();
      return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
    });

    this.filteredValues.sort(function (a, b) {
      var textA = a.label.toUpperCase();
      var textB = b.label.toUpperCase();
      return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
    });

  }

  cancel() {
    this.dialogRef.close(null);
  }

  confirm() {
    const result = new Array<TransportOptionParameterValue>();
    this.selectedValues.forEach((value) => {
      const item = this.data.available.find(x => x.id == value.id);
      if (item != null) {
        result.push(item);
      }
    });
    this.dialogRef.close(result);
  }

}
